import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import Storage from './utils/storage';

Vue.prototype.$storage = Storage;

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(BootstrapVue)

Vue.http.options.root = process.env.VUE_APP_API_URL;

let allowed_langs = ['en', 'pt', 'es', 'br'];

router.beforeEach((to, from, next) => {
	
	if(allowed_langs.indexOf(to.params.lang) === -1) {
		next({name: 'login', params: {lang: 'pt'}});
		return;
	}

  // set lang
  if(localStorage.getItem('user_lang') == null){
    to.params.lang = localStorage.lang;
  }else{
    to.params.lang = localStorage.user_lang;
  }

  if(to.params.lang !== from.params.lang) {
		localStorage.setItem('lang', to.params.lang);
		Vue.prototype.app_lang = localStorage.lang;
		Vue.prototype.trans = require('./langs/' +localStorage.lang+ '.js');
	}else if(typeof Vue.prototype.trans === 'undefined') {
		Vue.prototype.app_lang = localStorage.lang;
		Vue.prototype.trans = require('./langs/' +localStorage.lang+ '.js');
	}

	let local_data = Vue.prototype.$storage.get('data');
	let is_logged = localStorage.getItem('is_logged');

	if(to.meta.auth && (local_data === null || is_logged != 1)) {
		next({name: 'login', params: {lang: to.params.lang}});
		return;
	}
	else {
		next();
	}
});

let saveTimeout = null;
let globalData = new Vue({
  data: {
  	$distribution: Vue.prototype.$storage.get('data')
  }
});
Vue.mixin({
  computed: {
    $distribution: {
      get: function () { return globalData.$data.$distribution },
      set: function (newVal) {
      	globalData.$data.$distribution = newVal;
      }
    }
  },
  watch: {
    $distribution: {
      handler: function(new_val, old_val) {
        clearTimeout(saveTimeout);

        saveTimeout = setTimeout(() => {
            this.$storage.set('data', new_val);
        }, 300);
      },
      deep: true
    },
  },
  methods: {
    get_progress_class(r, z) {
      // if is zone responsible or room person
      if(r.cod_pessoa == this.$distribution.person.cod_pessoa || z.cod_pessoa == this.$distribution.person.cod_pessoa) { // it's just room allocated
        if(r.cleaning_times.some((item, idx) => item.cleaning_end !== null && item.cleaned_by === this.$distribution.person.cod_pessoa))
          return 'bg-success';
        if(r.cleaning_times.some((item, idx) => item.cleaning_start !== null && item.cleaned_by === this.$distribution.person.cod_pessoa))
          return 'bg-warning';
      }
      else if(this.$distribution.person.view_all == 1 // if master
          && r.cod_pessoa !== this.$distribution.person.cod_pessoa // and no room belongs to him/she
          && z.cod_pessoa !== this.$distribution.person.cod_pessoa // and not zone responsible
        ) {
        if(r.cleaning_times.length > 0) { // for
          if(r.cod_pessoa === null && r.cleaning_times[0].cleaning_end !== null) {
            return 'bg-success';
          }
          if(r.cod_pessoa === null && r.cleaning_times[0].cleaning_start !== null) {
            return 'bg-warning';
          }
          if (r.cleaning_times.length === 2 && r.cleaning_times.every((item, idx) => item.cleaning_end !== null)) { // if 
            return 'bg-success';
          }
          if(r.cleaning_times.some((item, idx) => item.cleaning_start !== null)) {
            return 'bg-warning';
          }
        }
      }
      return '';
    },
  	get_zone: function() {
      if(this.$distribution.zones){
    
        if( this.$route.params.cod_dist_zone ){
          return this.$distribution.zones.find((item, idx) => item.cod_distribution_zone == this.$route.params.cod_dist_zone);
        }

        return this.$distribution.zones;

      }else{
        return null;
      }
  	},
  	get_room: function(zone) {
  		return zone.rooms.find((item, idx) => item.cod_distribution_room == this.$route.params.cod_dist_room);
  	},
    get_room_status_name: function( room ){
      let room_status_name = room.room.status.name;
      
      if( localStorage.getItem('rooms_status') !== null ){
        let all_room_status = JSON.parse(localStorage.getItem('rooms_status'));
        let current_room_status = all_room_status.find(item => item.cod_room_status === room.room.cod_room_status);
        return current_room_status.name;          
      }

      return room_status_name;
    },
    get_reservation_state(room) {
        let default_state = '---';
        let check_in      = room.reservation_check_in;
        let check_out     = room.reservation_check_out;
            
        if( check_in && check_in.estado.cod_status == 4 && check_in.checkin_done == 1 ){
            return check_in.estado.name;
        }     
  
        if( check_out ){
            return check_out.estado.name;
        }

        return default_state;
    },
    get_state(room) {
        /*COD_ACAO:
            1 - Limpo c/ Entrada
            2 - Sujo
            3 - Ocupado
            4 - Saída c/ Entrada
            5 - Sujo c/ Entrada
            6 - Saída
            7 - Limpo (verificação)
        */
        let id   = 0;
        let name = room.action;
        if (room.room.cod_room_status == 2) {
            if ((room.reservation_check_in !== null) && room.reservation_check_in.d_checkin == room.reservation_check_in.d_current) {
                id   = 1;
                name = this.trans['LIMPO_C_ENTRADA'];
            } else {
                id   = 7;
                name = this.trans['LIMPO'];
            }
        } else if (room.room.cod_room_status == 1) {
            if (room.reservation_check_in !== null) {
                if (this.$distribution['num_reservations'][room.cod_room] && this.$distribution['num_reservations'][room.cod_room]['check_in'] != 0 && this.$distribution['num_reservations'][room.cod_room]['check_out'] != 0) {
                    id   = 4;
                    name = this.trans['SAIDA_C_ENTRADA'];
                } else if (room.reservation_check_in.d_checkin == room.reservation_check_in.d_current) {
                    id   = 5;
                    name = this.trans['SUJO_C_ENTRADA'];
                } else if (room.reservation_check_in.d_checkout == room.reservation_check_in.d_current) {
                    id   = 6;
                    name = this.trans['SAIDA'];
                } else {
                    id   = 3;
                    name = this.trans['OCUPADO'];
                }
            } else {
                id   = 2;
                name = this.trans['SUJO'];
            }
        } else if (room.room.status) {
            id   = 7;
            name = this.get_room_status_name(room);
        }

        return {
            id  : id,
            name: name
        };
    },
    isoLocalSimples(date = new Date()) {
        let pad = (n) => String(n).padStart(2, "0");

        let ano = date.getFullYear();
        let mes = pad(date.getMonth() + 1);
        let dia = pad(date.getDate());
        let hora = pad(date.getHours());
        let min = pad(date.getMinutes());
        let seg = pad(date.getSeconds());

        return `${ano}-${mes}-${dia} ${hora}:${min}:${seg}`;
    }
  }
})

Vue.component(
  'loader', 
  () => import(/* webpackChunkName: "loader" */ '@/components/Loader.vue')
);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
